import CampaignActions from "./CampaignActions";
import StatusChip from "./StatusChip";
import { clickThroughRate, currencyOf, formatCount, formatMoney, labelOf } from "./marketingFormat";

const HEAD =
  "px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-app-text-secondary";
const CELL = "px-3 py-3 align-top text-sm";

export default function CampaignsTable({
  campaigns,
  connections,
  perms,
  busy,
  onOpen,
  ...actions
}) {
  const showAccount = connections.length > 1;
  return (
    <div className="w-full overflow-x-auto rounded border border-app-border">
      <table className="min-w-full divide-y divide-app-border-subtle">
        <thead className="bg-app-surface-alt">
          <tr>
            <th className={HEAD}>Campaign</th>
            {showAccount ? <th className={HEAD}>Account</th> : null}
            <th className={HEAD}>Status</th>
            <th className={HEAD}>Budget / day</th>
            <th className={HEAD}>Spend</th>
            <th className={HEAD}>Results</th>
            <th className={HEAD}>Impressions</th>
            <th className={HEAD}>Clicks (CTR)</th>
            <th className={HEAD} aria-label="Actions" />
          </tr>
        </thead>
        <tbody className="divide-y divide-app-border-subtle">
          {campaigns.map((campaign) => {
            const currency = currencyOf(connections, campaign.connectionId);
            return (
              <tr key={campaign.id} className="hover:bg-app-surface-hover">
                <td className={CELL}>
                  <button
                    type="button"
                    className="text-left font-medium text-app-primary hover:underline"
                    onClick={() => onOpen(campaign)}
                  >
                    {campaign.name}
                  </button>
                  <div className="text-xs text-app-text-muted">
                    {campaign.sourcePostId
                      ? "Boosted post"
                      : campaign.objective?.replace("OUTCOME_", "")}
                    {campaign.durationDays ? ` · ${campaign.durationDays} days per start` : ""}
                  </div>
                </td>
                {showAccount ? (
                  <td className={CELL}>{labelOf(connections, campaign.connectionId)}</td>
                ) : null}
                <td className={CELL}>
                  <StatusChip campaign={campaign} />
                </td>
                <td className={CELL}>
                  {campaign.dailyBudgetCents > 0
                    ? formatMoney(campaign.dailyBudgetCents, currency)
                    : "-"}
                </td>
                <td className={CELL}>{formatMoney(campaign.spendCents, currency)}</td>
                <td className={CELL}>
                  {campaign.results == null ? (
                    "-"
                  ) : (
                    <>
                      {formatCount(campaign.results)}
                      <div className="text-xs text-app-text-muted">{campaign.resultLabel}</div>
                    </>
                  )}
                </td>
                <td className={CELL}>{formatCount(campaign.impressions)}</td>
                <td className={CELL}>
                  {formatCount(campaign.clicks)}
                  <span className="text-app-text-muted">
                    {" "}
                    ({clickThroughRate(campaign.clicks, campaign.impressions)})
                  </span>
                </td>
                <td className={CELL}>
                  <CampaignActions campaign={campaign} perms={perms} busy={busy} {...actions} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
